import React from 'react';
import { trackDownload } from '../../services/api';
import { trackEvent } from '../../utils/analytics';
import './DownloadSection.css';

const DownloadSection = () => {
  const handleDownloadClick = async (platform) => {
    try {
      // Track using our API
      await trackDownload(platform, 'download_page');

      // Track using analytics utility
      trackEvent('download_click', {
        platform: platform,
        source: 'website'
      });
    } catch (error) {
      console.error('Error tracking download:', error);

      // Still track with analytics even if API tracking fails
      trackEvent('download_click', {
        platform: platform,
        source: 'website'
      });
    }
  };

  return (
    <div className="download-section">
      <div className="container">
        <h2>Download Our App</h2>
        <p>Get started with AnyVolt today! Download our app to find and reserve EV charging stations.</p>

        <div className="download-buttons">
          <a
            href="https://apps.apple.com/app/anyvolt/id123456789"
            className="download-btn app-store"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleDownloadClick('ios')}
          >
            <div className="btn-icon">🍎</div>
            <div className="btn-text">
              <span className="btn-subtitle">Download on the</span>
              <span className="btn-title">App Store</span>
            </div>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.anyvolt.app"
            className="download-btn google-play"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleDownloadClick('android')}
          >
            <div className="btn-icon">🤖</div>
            <div className="btn-text">
              <span className="btn-subtitle">Get it on</span>
              <span className="btn-title">Google Play</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default DownloadSection;